/* Brossange : landings (C07). Offre de la landing (palier, finition de chaque brosse, ajout direct au panier par
   l'API du thème window.BrossangeCart.ajouter), paramètres d'URL ?palier=N et ?finition=..., barre d'achat mobile,
   UTM reportés sur les liens de la page liens. Attribution : brossange-attribution.js (C13) garde la première et la
   dernière visite après accord et l'API panier écrit les attributs à chaque ajout ; ce fichier ne stocke rien et
   n'écrit ces attributs qu'en secours,
   sans l'API, au même format. Annonces : une seule par action (celle de l'API quand elle est présente). Aucun prix
   n'est calculé côté client : les montants affichés viennent des métaobjets « palier », les remises des réductions
   automatiques. */
(() => {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const params = new URLSearchParams(window.location.search);
  const LANDING = (document.body && document.body.dataset.landing) || '';
  const UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const FINITIONS = ['noir', 'dore', 'rose-dore', 'argente'];

  // Valeurs d'URL nettoyées : lettres, chiffres, tiret, soulignement, point ; 80 caractères au plus
  const propre = (v) => String(v || '').trim().replace(/[^\w.\-]+/g, '_').slice(0, 80);

  // C12 : file commune lue par brossange-track.js (publication seulement avec l'accord « Analyse »)
  const publier = (nom, data) => {
    try { (window.brossangeQ = window.brossangeQ || []).push([nom, data]); } catch (e) { /* suivi facultatif */ }
  };
  // Même cible que l'API panier de C04 : région du dialogue ouvert (le reste de la page est inerte), sinon de la page
  const annoncer = (texte) => {
    const live = $('dialog[open] [data-live]') || $('#live-region');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = texte; }, 50);
  };
  const formatMoney = (cents) => {
    if (window.BrossangeCart && typeof window.BrossangeCart.formatMoney === 'function') return window.BrossangeCart.formatMoney(cents);
    return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} €`;
  };

  /* 1. Attribution. L'API panier de C04 (assets/brossange.js, section 5) garde la page d'arrivée et les UTM du
        dernier contact et les écrit en attributs de panier à chaque ajout : la landing n'écrit rien sur le terminal.
        Les UTM de l'URL servent à l'événement de vue et, en secours sans l'API, aux attributs écrits au moment de
        l'ajout (même format : _landing = chemin de la page, _utm_*, utm_term compris). */
  const utmUrl = {};
  UTM.forEach((k) => { if (params.get(k)) utmUrl[k] = propre(params.get(k)); });
  const attributsSecours = () => {
    const out = { _landing: String(window.location.pathname).slice(0, 120) };
    UTM.forEach((k) => { if (utmUrl[k]) out[`_${k}`] = utmUrl[k]; });
    return out;
  };
  if (LANDING) {
    publier('brossange_landing_view', {
      landing: propre(LANDING),
      utm_source: utmUrl.utm_source || null,
      utm_campaign: utmUrl.utm_campaign || null,
      utm_content: utmUrl.utm_content || null
    });
  }

  const requete = async (path, body) => {
    const res = await fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.description || data.message || 'Erreur panier');
      err.status = res.status;
      throw err;
    }
    return data;
  };

  const ouvrirPanier = () => {
    const api = window.BrossangeCart || {};
    if (typeof api.ouvrir === 'function') { api.ouvrir(); return; }
    const tiroir = document.getElementById('cart-drawer');
    if (!tiroir || tiroir.open || typeof tiroir.showModal !== 'function') return;
    tiroir.showModal();
    document.documentElement.style.overflow = 'hidden';
  };

  /* 2. Offre de la landing */
  const initOffre = (form) => {
    const paliers = $$('input[name="lp-palier"]', form);
    const slots = $$('[data-lp-slot]', form);
    const bouton = $('[data-lp-cta]', form);
    const libelleBouton = $('[data-lp-cta-label]', form);
    const statut = $('[data-lp-statut]', form);
    const note = $('[data-lp-note]', form);
    const section = form.closest('section');
    const brosse = section && $('[data-brosse]', section);
    const debut = form.dataset.cta || 'Ajouter au panier';
    const packHandle = /^[a-z0-9-]{1,60}$/.test(form.dataset.pack || '') ? form.dataset.pack : '';
    const packQuantite = Number(form.dataset.packQuantite) || 0;
    const etiquettePack = $('[data-lp-pack]', form);
    const source = propre(form.dataset.source || LANDING || 'landing');
    const barre = $(`[data-lp-barre][data-form="${form.id}"]`);
    const disponible = bouton && !bouton.disabled;

    const palierCoche = () => paliers.find((r) => r.checked) || null;
    const quantite = () => Number((palierCoche() || {}).value || 1);
    const prixPalier = () => {
      const r = palierCoche();
      return r ? Number(r.dataset.priceCents) : null;
    };
    // Le pack nommé ne vaut que pour sa quantité (comme sur la fiche) : un autre palier le retire des lignes
    const packActif = () => (packHandle && (!packQuantite || quantite() === packQuantite) ? packHandle : '');

    // Paramètres d'URL : ?palier=N (si ce palier est proposé), ?finition=... pour la première brosse
    const voulu = Number(params.get('palier'));
    if (voulu) {
      const radio = paliers.find((r) => Number(r.value) === voulu);
      if (radio) radio.checked = true;
    }
    const finUrl = String(params.get('finition') || '').toLowerCase();
    if (FINITIONS.includes(finUrl) && slots[0]) {
      const choix = $(`input[data-finition="${finUrl}"]`, slots[0]);
      if (choix && !choix.hasAttribute('data-indispo')) choix.checked = true;
    }

    const repeindre = (finition, suivi) => {
      if (!brosse || !FINITIONS.includes(finition) || brosse.dataset.finition === finition) return;
      brosse.dataset.finition = finition;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        brosse.classList.remove('is-plating');
        void brosse.offsetWidth;
        brosse.classList.add('is-plating');
      }
      if (suivi) publier('brossange_finition', { source: 'landing', finition });
    };

    const majSlots = () => {
      const n = quantite();
      slots.forEach((slot, i) => {
        const actif = i < n;
        slot.hidden = !actif;
        $$('input', slot).forEach((input) => {
          input.disabled = !actif || input.hasAttribute('data-indispo');
        });
        // Une brosse active sans finition disponible cochée : première finition disponible
        if (actif && !$('input[type="radio"]:checked:not([disabled])', slot)) {
          const libre = $('input[type="radio"]:not([disabled])', slot);
          if (libre) libre.checked = true;
        }
        const nom = $('[data-lp-slot-nom]', slot);
        const coche = $('input[type="radio"]:checked', slot);
        if (nom && coche) nom.textContent = coche.dataset.nom || '';
      });
      const premier = slots[0] && $('input[type="radio"]:checked', slots[0]);
      if (premier) repeindre(premier.dataset.finition, false);
      if (etiquettePack) etiquettePack.hidden = !packActif();
    };

    const majPrix = () => {
      if (!disponible) return;
      const cents = prixPalier();
      const texte = cents !== null ? `${debut}, ${formatMoney(cents)}` : debut;
      if (libelleBouton) libelleBouton.textContent = texte;
      if (barre) {
        const r = palierCoche();
        const lib = $('[data-lp-barre-libelle]', barre);
        const prix = $('[data-lp-barre-prix]', barre);
        if (lib) lib.textContent = r ? (r.dataset.libelle || '') : debut;
        if (prix) prix.textContent = cents !== null ? formatMoney(cents) : '';
      }
    };

    form.addEventListener('change', (event) => {
      const cible = event.target;
      if (cible.name === 'lp-palier') {
        majSlots();
        majPrix();
        publier('brossange_select_pack', { nb_brosses: quantite(), total_centimes: prixPalier() || 0, source: 'landing', landing: source });
      } else if (cible.matches('[data-lp-slot] input[type="radio"]')) {
        const slot = cible.closest('[data-lp-slot]');
        const nom = slot && $('[data-lp-slot-nom]', slot);
        if (nom) nom.textContent = cible.dataset.nom || '';
        if (slot === slots[0]) repeindre(cible.dataset.finition, true);
      }
    });

    // Lignes du panier : une ligne par finition, quantité regroupée, propriété _pack si la landing porte un pack
    const lignes = () => {
      const n = quantite();
      const compte = new Map();
      if (slots.length) {
        slots.slice(0, n).forEach((slot) => {
          const coche = $('input[type="radio"]:checked', slot);
          if (coche) compte.set(coche.value, (compte.get(coche.value) || 0) + 1);
        });
      } else {
        const id = $('input[name="items[0][id]"]', form);
        if (id) compte.set(id.value, n);
      }
      const pack = packActif();
      return Array.from(compte, ([id, quantity]) => (pack ? { id: Number(id), quantity, properties: { _pack: pack } } : { id: Number(id), quantity }));
    };

    // Secours : la fiche produit avec le palier et le pack préremplis
    const redirigerFiche = (items) => {
      const url = new URL(form.dataset.url || '/', window.location.origin);
      url.searchParams.set('quantity', String(quantite()));
      if (packActif()) url.searchParams.set('pack', packActif());
      if (items[0]) url.searchParams.set('variant', String(items[0].id));
      window.location.assign(url.toString());
    };

    const ajouter = async () => {
      const items = lignes();
      if (!items.length) {
        const msg = 'Choisissez la finition de chaque brosse.';
        if (statut) statut.textContent = msg;
        annoncer(msg);
        return;
      }
      const api = window.BrossangeCart || {};
      const avecApi = typeof api.ajouter === 'function';
      let parApi = false;
      // Message cadeau : mêmes attributs que la case cadeau du panier (C04) ; attribution écrite ici en secours seulement
      const attributs = avecApi ? {} : (window.BrossangeAttribution ? window.BrossangeAttribution.attributs() : attributsSecours());
      const message = note && !note.disabled && note.value.trim() ? note.value.trim().slice(0, 200) : '';
      if (message) Object.assign(attributs, { Cadeau: 'Oui', 'Message cadeau': message });
      bouton.setAttribute('aria-busy', 'true');
      if (statut) statut.textContent = '';
      try {
        // Attributs d'abord (le panier est créé s'il n'existe pas), puis l'ajout
        if (Object.keys(attributs).length) await requete('cart/update.js', { attributes: attributs });
        if (avecApi) {
          // API du panier du thème (C04) : file d'attente, chouchou, attribution, annonce, tiroir et
          // brossange_add_to_cart. Rien de plus ici : une seule annonce, une seule ouverture du tiroir.
          parApi = true;
          await api.ajouter(items, 'landing', { pack: packActif() || null, nb_brosses: quantite(), total_centimes: prixPalier() });
          return;
        }
        if (typeof api.refresh !== 'function') {
          redirigerFiche(items);
          return;
        }
        // Secours sans l'API d'ajout : panier natif, rendu du tiroir, événement, annonce et ouverture par la landing
        await requete('cart/add.js', { items });
        await api.refresh();
        publier('brossange_add_to_cart', { source: 'landing', landing: source, pack: packActif() || null, nb_brosses: quantite(), total_centimes: prixPalier() });
        const n = quantite();
        const msg = n > 1 ? `${n} brosses ajoutées au panier.` : 'Brosse ajoutée au panier.';
        if (statut) statut.textContent = msg;
        annoncer(msg);
        ouvrirPanier();
      } catch (err) {
        const msg = err && err.status === 422
          ? (err.message || 'Cette brosse n\'a pas pu être ajoutée.')
          : 'La connexion a coupé. Réessayez dans un instant.';
        // Message visible près du bouton ; l'API de C04 l'a déjà annoncé quand l'erreur vient d'elle
        if (statut) statut.textContent = msg;
        if (!parApi) annoncer(msg);
      } finally {
        bouton.removeAttribute('aria-busy');
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!disponible || bouton.getAttribute('aria-busy') === 'true') return;
      ajouter();
    });

    /* Barre d'achat mobile : affichée quand le bouton de l'offre n'est plus visible */
    if (barre && bouton && 'IntersectionObserver' in window) {
      const bascule = (visible) => barre.classList.toggle('is-visible', !visible);
      new IntersectionObserver((entrees) => entrees.forEach((e) => bascule(e.isIntersecting)), { threshold: 0 }).observe(bouton);
      const action = $('[data-lp-barre-bouton]', barre);
      if (action) {
        action.addEventListener('click', () => {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else ajouter();
        });
      }
    }

    majSlots();
    majPrix();
  };
  $$('[data-landing-offre]').forEach(initOffre);

  /* 3. Page liens : les UTM d'arrivée (bio TikTok, QR d'un colis) remplacent source, support, campagne et
        créative préremplis ; un paramètre absent à l'arrivée est retiré. utm_term garde le nom du lien. */
  const ARRIVEE = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  if (ARRIVEE.some((k) => params.get(k))) {
    $$('a[data-lien-utm]').forEach((lien) => {
      try {
        const url = new URL(lien.getAttribute('href'), window.location.origin);
        ARRIVEE.forEach((k) => {
          if (params.get(k)) url.searchParams.set(k, propre(params.get(k)));
          else url.searchParams.delete(k);
        });
        lien.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) { /* lien laissé tel quel */ }
    });
  }
})();
